// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__1lRsI","input":"checkbox_input__1N_3y","text":"checkbox_text__3WbQ4","error":"checkbox_error__oG9nz"};